// import { useCallback, useState } from 'react'
// import { useDispatch } from 'react-redux'
// import { AppDispatch } from '../../../store'
// import SetPasswordForm from '../../forms/SetPasswordForm'
// import { IWizzard } from '../ForgotPasswordWizzard'
// import { useNavigate, useSearchParams } from 'react-router-dom'
// import SetPasswordSuccessForm from '../../forms/SetPasswordSuccessForm'
// import { resetPassword } from '../../../store/auth/authSlice'
// import { useForm } from 'react-hook-form'
// import { vestResolver } from '@hookform/resolvers/vest'
// import { formValidation } from './utils'
// import { IGenericObjectStringValue } from '../../../types'
// import { formTypes } from './types'

// const defaultValues = { password: '', passwordRepeat: '' }

// const SetPasswordWizzard = () => {
//   const [searchParams] = useSearchParams()
//   const [currentStep, setCurrentStep] = useState<number>(1)

//   const navigate = useNavigate()
//   const dispatch = useDispatch<AppDispatch>()

//   const onSubmit = (data: any) => {
//     const token = searchParams.get('token')
//     if (token) {
//       dispatch(resetPassword({ password: data.password, token }))
//       setCurrentStep(2)
//     }
//   }

//   const navigateToLogin = () => {
//     navigate('/login')
//   }

//   const formMethods = useForm<IGenericObjectStringValue>({
//     defaultValues,
//     resolver: vestResolver(formValidation),
//     mode: 'onChange',
//     shouldFocusError: false,
//   })

//   const { register, handleSubmit, formState } = formMethods

//   const getMessage = useCallback(
//     (field: formTypes) => {
//       if (!formState.errors[field]) return ''

//       return formState.errors[field]!.message
//     },
//     [formState],
//   )

//   const wizzardSteps: IWizzard = {
//     1: (
//       <SetPasswordForm
//         register={register}
//         passwordError={getMessage('password')}
//         passwordRepeatError={getMessage('password_repeat')}
//       />
//     ),
//     2: <SetPasswordSuccessForm navigateToLogin={navigateToLogin} />,
//   }

//   const resolveStep = () => {
//     return wizzardSteps[currentStep]
//   }

//   return <form onSubmit={handleSubmit(onSubmit)}>{resolveStep()}</form>
// }

// export default SetPasswordWizzard


import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import SetPasswordForm from '../../forms/SetPasswordForm';
import { IWizzard } from '../ForgotPasswordWizzard';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SetPasswordSuccessForm from '../../forms/SetPasswordSuccessForm';
import { resetPassword } from '../../../store/auth/authSlice';
import { useForm } from 'react-hook-form';
import { vestResolver } from '@hookform/resolvers/vest';
import { formValidation } from './utils';
import { IGenericObjectStringValue } from '../../../types';
import { formTypes } from './types';

const defaultValues = { password: '', password_repeat: '' };

const SetPasswordWizzard = () => {
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState<number>(1);

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const onSubmit = (data: any) => {
    const token = searchParams.get('token');
    if (token) {
      dispatch(resetPassword({ password: data.password, token }));
      setCurrentStep(2);
    }
  };

  const navigateToLogin = () => {
    navigate('/login');
  };

  const formMethods = useForm<IGenericObjectStringValue>({
    defaultValues,
    resolver: vestResolver(formValidation),
    mode: 'onChange',
    shouldFocusError: false,
  });

  const { register, handleSubmit, formState } = formMethods;

  const getMessage = useCallback(
    (field: formTypes) => {
      if (!formState.errors[field]) return '';
      return formState.errors[field]!.message;
    },
    [formState],
  );

  const wizzardSteps: IWizzard = {
    1: (
      <SetPasswordForm
        register={register}
        passwordError={getMessage('password')}
        passwordRepeatError={getMessage('password_repeat')}
      />
    ),
    2: <SetPasswordSuccessForm navigateToLogin={navigateToLogin} />,
  };

  const resolveStep = () => wizzardSteps[currentStep];

  return <form onSubmit={handleSubmit(onSubmit)}>{resolveStep()}</form>;
};

export default SetPasswordWizzard;
